import React from "react";

const CountryPaymentGatewayModal = ({
    isOpen,
    title,
    children,
    onClose,
    footer,
}) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50">
            <div
                className="absolute inset-0 bg-slate-900/50 backdrop-blur-sm"
                style={{ animation: "cpgFadeIn 0.15s ease-out" }}
                onClick={onClose}
            />

            <div className="absolute inset-0 flex items-center justify-center p-4 sm:p-6">
                <div
                    className="w-full max-w-2xl overflow-hidden rounded-2xl bg-white shadow-2xl ring-1 ring-black/5"
                    style={{ animation: "cpgScaleIn 0.18s ease-out" }}
                    onClick={(e) => e.stopPropagation()}
                >
                    <div className="flex items-center justify-between border-b border-slate-100 px-6 py-5">
                        <h2 className="text-lg font-semibold text-slate-900">{title}</h2>

                        <button
                            onClick={onClose}
                            aria-label="Close"
                            className="flex h-8 w-8 items-center justify-center rounded-full text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-700"
                        >
                            <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2">
                                <path strokeLinecap="round" d="M18 6 6 18M6 6l12 12" />
                            </svg>
                        </button>
                    </div>

                    <div className="max-h-[70vh] overflow-y-auto px-6 py-6">{children}</div>

                    <div className="flex justify-end gap-3 border-t border-slate-100 bg-slate-50/60 px-6 py-4">
                        {footer}
                    </div>
                </div>
            </div>

            <style>{`
                @keyframes cpgFadeIn { from { opacity: 0 } to { opacity: 1 } }
                @keyframes cpgScaleIn {
                    from { opacity: 0; transform: scale(0.96) translateY(4px) }
                    to { opacity: 1; transform: scale(1) translateY(0) }
                }
            `}</style>
        </div>
    );
};

export default CountryPaymentGatewayModal;